import { useEffect, useState } from "react";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import {
  FaArrowUp,
  FaEnvelope,
  FaLinkedin,
  FaLocationDot,
  FaPhone,
  FaXTwitter,
} from "react-icons/fa6";
import { companyInfo } from "../data/siteContent";
import bigLogo from "../assets/biglogocopy.png";

export default function Footer() {
  // App context not required in footer layout
  const [ready, setReady] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    setReady(true);

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;
      setShowScrollTop(scrollTop > 300);
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  if (!ready) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center">{getInlineLoader()}</div>
      </div>
    );
  }

  const socialLinks = [
    { icon: <FaLinkedin />, href: "#", label: "LinkedIn" },
    { icon: <FaXTwitter />, href: "#", label: "Twitter" },
  ];

  const contactItems = [
    {
      icon: <FaLocationDot />,
      label: companyInfo.address,
      href: "https://maps.google.com/?q=Minet+House+488+Haile+Selassie+Rd+Dar+es+Salaam",
    },
    {
      icon: <FaPhone />,
      label: companyInfo.phoneDisplay,
      href: companyInfo.phoneLink,
    },
    {
      icon: <FaEnvelope />,
      label: companyInfo.email,
      href: `mailto:${companyInfo.email}`,
    },
  ];

  return (
    <footer className="ags-footer py-5">
  <div className="container">

    <div className="text-center">

      <img
        src={bigLogo}
        alt={companyInfo.shortName}
        className="ags-footer-logo mb-2"
      />

      <h5 className="text-white fw-bold mb-3">
        {companyInfo.name}
      </h5>

      <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
        {contactItems.map((item) => (
          <a
            key={item.label}
            href={item.href}
            className="text-white-50 text-decoration-none small d-flex align-items-center gap-2"
          >
            {item.icon}
            <span>{item.label}</span>
          </a>
        ))}
      </div>

      <div className="d-flex justify-content-center gap-3 mb-4">
        {socialLinks.map((social) => (
          <a
            key={social.label}
            href={social.href}
            className="ags-social-icon"
          >
            {social.icon}
          </a>
        ))}
      </div>
    </div>

    <hr className="border-white" />

    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white-50 small">
      <span>
        © {getCurrentYear()} {companyInfo.shortName}
      </span>

      <span>
        Website by{" "}
        <a
          href="https://werenium.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-secondary text-decoration-none"
        >
          Werenium Technologies
        </a>
      </span>
    </div>

  </div>
</footer>
  );
}
